import apiService from './api';
import {
  Project,
  ProjectDetail,
  CreateProjectData,
  UpdateProjectData,
} from '@/types/project';

class ProjectService {
  /**
   * Get all projects for the current organization
   * Backend returns an array directly, not a paginated response
   */
  async getProjects(): Promise<Project[]> {
    return apiService.get<Project[]>('/projects');
  }

  /**
   * Get a single project by ID
   */
  async getProject(id: string): Promise<ProjectDetail> {
    return apiService.get<ProjectDetail>(`/projects/${id}`);
  }

  /**
   * Create a new project
   * Note: organization_id is automatically set from the authenticated user's context
   */
  async createProject(data: CreateProjectData): Promise<Project> {
    return apiService.post<Project>('/projects', data);
  }

  /**
   * Update an existing project
   */
  async updateProject(id: string, data: UpdateProjectData): Promise<Project> {
    return apiService.patch<Project>(`/projects/${id}`, data);
  }

  /**
   * Delete (soft delete) a project
   */
  async deleteProject(id: string): Promise<void> {
    return apiService.delete<void>(`/projects/${id}`);
  }

  /**
   * Add a member to a project
   */
  async addMember(projectId: string, userId: string, role: string = 'project_user'): Promise<void> {
    return apiService.post<void>(`/projects/${projectId}/members`, {
      user_id: userId,
      role,
    });
  }

  /**
   * Remove a member from a project
   */
  async removeMember(projectId: string, userId: string): Promise<void> {
    return apiService.delete<void>(
      `/projects/${projectId}/members/${userId}`
    );
  }

  /**
   * Get all members of a project
   */
  async getProjectMembers(projectId: string): Promise<any[]> {
    return apiService.get<any[]>(`/projects/${projectId}/members`);
  }
}

export const projectService = new ProjectService();
export default projectService;
